import React, { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ImageLoader from "../../../Common/ImageLoader";
import { increaseViewCount } from "../../../Common/CommonMethods";
import * as actionTypes from "../../../../store/actions/actionTypes";
import LeadGen from "../../../Common/Popups/LeadGen";

const fallbackPhoto = "/images/avatar.webp";

const VideoBox = (props) => {
  const [isLeadGenPopUp, setLeadGenPopUp] = useState(false);
  const [isEntered, setEntered] = useState(false);
  const regex = /youtube.com/g;
  const isYoutube = Boolean(props.link.match(regex));

  const postLeadRegPopUp = (isEnterpriseLoginStatus) => {
    if (!isEnterpriseLoginStatus) {
      props.setPopUp({
        ...props,
        isPopUpActive: true,
        toLocation: props.location.pathname,
      });
      props.history.push(
        `/vendor/${props.match.params.id}/customer-videos/popup`
      );
    }
  };

  const getClassByOptions = (isYoutube, lockedPremium) => {
    if (!isYoutube && lockedPremium) {
      return `video_vimeo premium_vendor`;
    } else if (isYoutube && lockedPremium) {
      return `premium_vendor`;
    } else if (!isYoutube && !lockedPremium) {
      return `video_vimeo`;
    }
  };

  // removed from li className={getClassByOptions(isYoutube, props.premiumVendor)}
  return (
    <li>
      <div className="video_thumbnail">
        <ImageLoader
          image={props.thumbnail}
          fallbackImage={`/images/FC_placeholder_video_thumb_${props.imageIndex}.webp`}
          width={417}
          height={180}
        />
      </div>
      <div class="play_video_btn">
        <a
          href="#"
          className="open-overlay"
          onClick={(e) => {
            e.preventDefault();
            if (props.location.pathname.includes("/premium/preview")) {
              return;
            }
            if (props.isLeadGenPopUp) {
              setLeadGenPopUp(true);
            } else {
              if (!!props.link) {
                increaseViewCount(
                  process.env.REACT_APP_API_URL,
                  "cv",
                  props.id
                );
              }
              props.setPopUp({
                ...props,
                isPopUpActive: true,
                toLocation: props.location.pathname,
              });
              if (!!props.match.params.id) {
                props.history.push(
                  `/vendor/${props.match.params.id}/customer-videos/popup`
                );
              } else if (!!props.match.params.company) {
                //
                props.history.push(
                  `/vendor/${props.match.params.company}/customer-videos/popup`
                );
              } else {
                // do nothing
              }
            }
          }}
        >
          Play Video
        </a>
      </div>
      <div className="footer_bottom footer_bottom_video">
        {Object.keys(props.contactdetail).length > 0 ? (
          <div className="user_details">
            <span className="name">{props.contactdetail.name}</span>
            <span className="desgn">{props.contactdetail.jobtitle}</span>
          </div>
        ) : null}
      </div>

      {isLeadGenPopUp ? (
        <LeadGen
          {...props}
          setLeadGenPopUp={setLeadGenPopUp}
          postLeadRegPopUp={postLeadRegPopUp(props.isEnterpriseLogin)}
          pathname={props.pathname.replace("/customer-videos", "")}
          linkedInUrl={props.linkedInUrl}
        />
      ) : null}
    </li>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    setPopUp: (data) =>
      dispatch({ type: actionTypes.SET_VIDEO_ACTIVE_POPUP, payload: data }),
  };
};
const mapStateToProps = (state) => {
  return {
    isEnterpriseLogin: state.homePage.isEnterpriseLogin,
  };
};

const VideoBoxWithRouter = withRouter(VideoBox);
export default connect(mapStateToProps, mapDispatchToProps)(VideoBoxWithRouter);
